export default __webpack_public_path__ + "static/media/25.e2a79648.png";